import request from "../utils/axios";
import settings from "../settings/settings";

export const getProducts = (params) => {
    return request({ method: "GET", url: "/products", params, baseURL: settings.catalogBaseURL });
};

export const createProduct = (data) => {
    return request({ method: "POST", url: "/products", data, baseURL: settings.catalogBaseURL });
};

export const editProduct = (data) => {
    return request({ method: "PUT", url: `/products/${data.id}`, data, baseURL: settings.catalogBaseURL });
};

export const getProductById = (id) => {
    return request({ method: "GET", url: `/products/${id}`, baseURL: settings.catalogBaseURL });
};

export const deleteProduct = (id) => {
    return request({ method: "DELETE", url: `/products/${id}`, baseURL: settings.catalogBaseURL });
};

export const createDefaultProduct = (params) => {
    return request({ method: "POST", url: "/products/default", params, baseURL: settings.catalogBaseURL });
};

export const addProductPrice = (data) => {
    return request({ method: "POST", url: "/products/price", data, baseURL: settings.catalogBaseURL });
};

export const editProductPrice = (priceId, data) => {
    return request({ method: "PUT", url: `/products/price/${priceId}`, data, baseURL: settings.catalogBaseURL });
};

export const deleteProductPrice = (priceId) => {
    return request({ method: "DELETE", url: `/products/price/${priceId}`, baseURL: settings.catalogBaseURL });
};

export const getSellerProducts = (sellerId, params) => {
    return request({ method: "GET", url: `/sellers/${sellerId}/products`, params, baseURL: settings.catalogBaseURL });
};

export const uploadProductImage = (data) => {
    return request({ method: "POST", url: "/products/image", data, baseURL: settings.catalogBaseURL, headers: { "Content-Type": "multipart/form-data" } });
};

export const updateProductImage = (data) => {
    return request({ method: "PUT", url: "/products/image", data, baseURL: settings.catalogBaseURL, headers: { "Content-Type": "multipart/form-data" } });
};
